import { useEffect } from 'react';
import { Line, TextNote } from '../components/Canvas/types';

export const useClipboardCopy = (
  selection: string[],
  drawingState: { lines: Line[]; textNotes?: TextNote[] }
) => {
  useEffect(function () {
    function handleCopy(e: Event) {
      var evt = e as ClipboardEvent;
      if (selection.length === 0) return;

      var selectedLines = drawingState.lines.filter(function (l) {
        return selection.indexOf(l.id) !== -1;
      });
      var selectedTexts = (drawingState.textNotes || []).filter(function (n) {
        return selection.indexOf(n.id) !== -1;
      });

      var payload = JSON.stringify({ lines: selectedLines, textNotes: selectedTexts });
      evt.clipboardData?.setData('text/plain', payload);
      evt.preventDefault();
    }

    document.addEventListener('copy', handleCopy, false);
    return function () {
      document.removeEventListener('copy', handleCopy, false);
    };
  }, [selection, drawingState]);
};